<template>
  <b-form
    v-if="initialised"
    @submit.prevent="onSubmit"
    @keydown="form.errors.clear($event.target.id)"
  >
    <div class="row">
      <div class="col">
        <b-card>
          <template #header>
            <b>Tribute</b>
          </template>

          <form-text v-model="form.name" name="name" maxlength="256" :required="true" />

          <div class="form-row mb-3">
            <label class="col-3 col-form-label text-right">Logo</label>
            <div class="col-8 uploader-button">
              <file-uploader
                :file-url="form.logo"
                :image-preview="true"
                @uploaded="saveUpload($event, 'logo')"
              />
            </div>
          </div>
          <div class="form-row mb-3">
            <label class="col-3 col-form-label text-right">Logo Medium</label>
            <div class="col-8 uploader-button">
              <file-uploader
                :file-url="form.logo_medium"
                :image-preview="true"
                @uploaded="saveUpload($event, 'logo_medium')"
              />
            </div>
          </div>
          <div class="form-row mb-3">
            <label class="col-3 col-form-label text-right">Logo Large</label>
            <div class="col-8 uploader-button">
              <file-uploader
                :file-url="form.logo_large"
                :image-preview="true"
                @uploaded="saveUpload($event, 'logo_large')"
              />
            </div>
          </div>

          <form-textarea v-model="form.description" name="description" />
          <form-text v-model="form.video" name="video" />
          <form-text v-model="form.goal" name="goal" :is-number="true" step="1" />
          <form-date v-model="form.start" name="start" value-format="yyyy-MM-dd" />
          <form-date v-model="form.end" name="end" value-format="yyyy-MM-dd" />
        </b-card>
      </div>
    </div>

    <b-card-footer class="mb-5">
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-primary" :disabled="form.notReady()">
            <font-awesome-icon v-if="form.busy" spin :icon="['fal', 'spinner']" />
            <font-awesome-icon v-else :icon="['fal', 'check']" />
            {{ crud.getAction() === "create" ? "Create" : "Save" }}
          </button>
        </div>
      </div>
    </b-card-footer>
  </b-form>
</template>

<script type="text/babel">
import FileUploader from "../../components/common/FileUploader.vue";

const typeOptions = ["Percentage", "Amount"];

export default {
  components: {
    FileUploader,
  },

  data() {
    return {
      typeOptions,
      crud: null,
      form: new window.AppForm({
        name: null,
        logo: null,
        logo_medium: null,
        logo_large: null,
        description: null,
        video: null,
        goal: null,
        start: null,
        end: null,
      }),
      initialised: false,
    };
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.crud = new window.AppCrud("tribute");

      this.form.reset();

      if (this.crud.getAction() === "create") {
        this.initialised = true;
        return;
      }

      this.crud.initFormData(this.form).then(() => {
        this.initialised = true;
      });
    },

    saveUpload(url, type) {
      this.form[type] = url;
    },

    onSubmit() {
      this.crud.submit(this.form).then((response) => {
        if (this.crud.getAction() === "create") {
          window.toastr.success("New Tribute created!", "Success");

          this.$router.push(
            {
              name: "tributes.edit",
              params: { id: response.tribute.id },
            },
            () => {
              this.init();
            }
          );
        } else {
          this.init();
          window.toastr.success("Tribute updated!", "Success");
        }
      });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
::v-deep .file-uploader__preview,
::v-deep .file-uploader__preview img,
::v-deep .file-uploader__edit-image {
  max-height: 150px;
}
</style>
